// extracted by mini-css-extract-plugin
module.exports = {"sector":"sector__WIe0FWu-6zHHp","textWrap":"textWrap__Bctqy8XM0mywb","text":"text__gv4LI1ZCZEBnF"};